import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { selectOrderRegions } from '@AMIEWEB/Order/Store/Order.selectors';
import { orderCreationNewActions } from '@AMIEWEB/NewOrder/Store/OrderCreation.actions';
import { selectedOrderTypeDetails } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import { calculateRegionDefaultValue } from '../helper';
import { selectFacility } from '@AMIEWEB/Facility/FacilityStore/Facility.selector';

export const Region = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const regions = useSelector(selectOrderRegions);
  const facilityDetails = useSelector(selectFacility);
  const page1 = useSelector(selectedOrderTypeDetails);
  const { control, setValue, register } = useFormContext();
  const region = useWatch({ name: 'region' });
  register(`regionId`);

  const { facilityResponse: facilityData } = facilityDetails;
  useEffect(() => {
    if (!region && regions?.length && facilityData?.location?.regionId && facilityData?.amnDivisionTypeId) {
      const defaultRegion = calculateRegionDefaultValue(facilityData, regions);
      const defaultRegionDesc = defaultRegion?.Description ?? '';
      const defaultRegionId = defaultRegion?.ID ?? '';
      if (page1 && defaultRegion) {
        dispatch(
          orderCreationNewActions.setPage1FormData(
            cloneDeep({
              ...page1,
              region: defaultRegionDesc,
              regionId: Number(defaultRegionId),
            }),
          ),
        );
      }

      setValue('region', defaultRegionDesc);
      setValue('regionId', defaultRegionId);
    }
  }, [facilityData, regions, region, setValue, dispatch, page1]);

  return (
    <>
      <Controller
        control={control}
        name={'region'}
        rules={{ required: true }}
        render={({ field: { onChange, value, ...rest } }) => (
          <FormInputDropdown
            name={'region'}
            label={`${t('order.newOrderCreation.tabs.orderTypeDetail.region')} ${t('*')}`}
            require={true}
            standard={true}
            inputValue={region ?? ''}
            options={regions ?? []}
            handleChange={e => {
              onChange(e);
              setValue('regionId', regions?.find(item => item.Description === e.target.value)?.ID);
            }}
            showErrorAttribute={value ? false : true}
            isOrderCreationElement={true}
          />
        )}
      />
    </>
  );
};
